import React from 'react';
import classNames from 'classnames';

type Props = {
  children: any;
  className?: string;
  color?: 'inherit' | 'primary' | 'secondary';
  disabled?: boolean;
  download?: string;
  href?: string;
  onClick?: () => void;
  variant?: 'text' | 'outlined' | 'contained';
};

const Button = ({ children, download, href, onClick, disabled, className }: Props): JSX.Element => {
  const cssClasses = classNames(
    className,
    'py-2 px-6 border no-underline border-transparent text-sm font-medium rounded-md text-white',
    disabled
      ? 'bg-gray-300'
      : 'bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 shadow-md',
  );

  if (href) {
    return (
      <a onClick={onClick} className={`${cssClasses} inline-block`} href={href} download={download}>
        {children}
      </a>
    );
  }
  return (
    <button onClick={onClick} className={cssClasses} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
